<template>
  <div id="icon_footer"
       v-if="iconIsShow">
    <img src="../../assets/img/icon_footer_half_round.png" />
  </div>
</template>
<script>
export default {
  name: 'G-i-footer',
  data () {
    return {
      msg: '技术支持-阿中软件'
    }
  },
  props: {
    iconIsShow: {
      type: Boolean,
      default: true
    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style scoped>
#icon_footer {
  text-align: center;
  position: fixed;
  bottom: 36px;
  width: 100%;
  z-index: 0;
  left: 0px;
}
#icon_footer > img {
  width: 35%;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/HalfRoundIconFooter/index.vue